import _ from 'lodash';

export default class WorkflowResource {
    loadListingWorkflow(isWorkflowAll, hasfeature) {
        if (isWorkflowAll || hasfeature)
            return [
                {
                    type: 'congrats-email',
                    stepId: 'dbc29b5b-d311-440b-b524-95d16b43ae99',
                    title: 'Send Congrats Email',
                },
                {
                    type: 'confirm-read',
                    stepId: 'ed28860c-58a6-4d2f-816f-21eac1637381',
                    title: 'Agent Preferences',
                },
                {
                    type: 'file-setup-email',
                    stepId: 'e078f1ee-4f9e-438c-b4b1-858ff8d12c2e',
                    title: 'Confirmation of File Set-Up',
                },
                {
                    type: 'convert-listing',
                    stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09',
                    title: 'Accept Contract',
                },
            ];
        return [{ type: 'convert-listing', stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09', title: 'Accept Contract' }];
    }

    loadListingToListingGonePendingWorkflow(isWorkflowAll, hasfeature) {
        if (isWorkflowAll || hasfeature)
            return [
                {
                    type: 'congrats-email',
                    stepId: 'dbc29b5b-d311-440b-b524-95d16b43ae99',
                    title: 'Send Congrats Email',
                },
                {
                    type: 'confirm-read',
                    stepId: 'ed28860c-58a6-4d2f-816f-21eac1637381',
                    title: 'Agent Preferences',
                },
                {
                    type: 'file-setup-email',
                    stepId: 'e078f1ee-4f9e-438c-b4b1-858ff8d12c2e',
                    title: 'Send Confirmation of File Set-Up',
                },
                {
                    type: 'convert-listing',
                    stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09',
                    title: 'Accept Contract',
                },
                {
                    type: 'congrats-email-listing-gone-pending',
                    stepId: '3854cc79-f8ed-43be-9e23-2c5d7cee7579',
                    title: 'Send Listing Gone Pending Congrats Email',
                },
                {
                    type: 'confirm-read',
                    stepId: '3cb68674-eb67-4401-a86b-ff691a22b9fd',
                    title: 'Agent Preferences',
                },
                {
                    type: 'calendar',
                    stepId: '572ace14-fb4a-4fdb-8acc-c9f4c3260c45',
                    title: 'Calendar Timeline',
                },
                {
                    type: 'introduction-seller-email',
                    stepId: '03582d10-0c12-4896-8d2d-42d343cdfeca',
                    title: 'Introduction to Seller',
                },
                {
                    type: 'client-introduction-co-op-agent-email-listing-gone-pending',
                    stepId: '7abe61ae-27ac-4ede-8932-5b85afee2197',
                    title: 'Introduction to Co-op Agent',
                },
                {
                    type: 'intro-email-escrow-title',
                    stepId: '01de5ebb-78a5-4241-b787-2cf8846cf127',
                    title: 'Escrow/Title TC Introduction',
                },
                {
                    type: 'create-invoice',
                    stepId: '21b9897a-132f-4cd5-bc1f-31f12e0be5ef',
                    title: 'Create Invoice',
                },
                {
                    type: 'send-invoice',
                    stepId: 'abce0151-1e2b-43a9-ac63-3d214b3bc091',
                    title: 'Send Invoice',
                },
                {
                    type: 'file-setup-email-listing-gone-pending',
                    stepId: '9a89905a-bc78-4d0f-acca-4a2a1365ab72',
                    title: 'Confirmation of File Set-Up',
                },
            ];
        return [{ type: 'convert-listing', stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09', title: 'Accept Contract' }];
    }

    loadPreConvertedListingGonePendingWorkflow(isWorkflowAll, hasfeature) {
        if (isWorkflowAll || hasfeature)
            return [
                {
                    type: 'congrats-email-listing-gone-pending',
                    stepId: '3854cc79-f8ed-43be-9e23-2c5d7cee7579',
                    title: 'Send Listing Gone Pending Congrats Email',
                },
                {
                    type: 'confirm-read',
                    stepId: 'ed28860c-58a6-4d2f-816f-21eac1637381',
                    title: 'Agent Preferences',
                },
                {
                    type: 'convert-listing',
                    stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09',
                    title: 'Accept Contract',
                },
            ];
        return [{ type: 'convert-listing', stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09', title: 'Accept Contract' }];
    }

    loadListingGonePendingWorkflow(isWorkflowAll, hasfeature) {
        if (isWorkflowAll || hasfeature)
            return [
                {
                    type: 'congrats-email-listing-gone-pending',
                    stepId: '3854cc79-f8ed-43be-9e23-2c5d7cee7579',
                    title: 'Send Listing Gone Pending Congrats Email',
                },
                {
                    type: 'confirm-read',
                    stepId: 'ed28860c-58a6-4d2f-816f-21eac1637381',
                    title: 'Agent Preferences',
                },
                {
                    type: 'convert-listing',
                    stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09',
                    title: 'Accept Contract',
                },
                {
                    type: 'calendar',
                    stepId: '572ace14-fb4a-4fdb-8acc-c9f4c3260c45',
                    title: 'Calendar Timeline',
                },
                {
                    type: 'introduction-seller-email',
                    stepId: '03582d10-0c12-4896-8d2d-42d343cdfeca',
                    title: 'Introduction to Seller',
                },
                {
                    type: 'client-introduction-co-op-agent-email-listing-gone-pending',
                    stepId: '7abe61ae-27ac-4ede-8932-5b85afee2197',
                    title: 'Introduction to Co-op Agent',
                },
                {
                    type: 'intro-email-escrow-title',
                    stepId: '01de5ebb-78a5-4241-b787-2cf8846cf127',
                    title: 'Escrow/Title TC Introduction',
                },
                {
                    type: 'create-invoice',
                    stepId: '21b9897a-132f-4cd5-bc1f-31f12e0be5ef',
                    title: 'Create Invoice',
                },
                {
                    type: 'send-invoice',
                    stepId: 'abce0151-1e2b-43a9-ac63-3d214b3bc091',
                    title: 'Send Invoice',
                },
                {
                    type: 'file-setup-email-listing-gone-pending',
                    stepId: '9a89905a-bc78-4d0f-acca-4a2a1365ab72',
                    title: 'Confirmation of File Set-Up',
                },
            ];
        return [{ type: 'convert-listing', stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09', title: 'Accept Contract' }];
    }

    /**
     * A file started out as a type of sale of DE and is a listing
     * @param isWorkflowAll
     * @param hasfeature
     * @return {*[]}
     * @constructor
     */
    loadPreConvertedDoubleEndedWorkflow(isWorkflowAll, hasfeature) {
        if (isWorkflowAll || hasfeature)
            return [
                {
                    type: 'congrats-email-listing-gone-pending',
                    stepId: '3854cc79-f8ed-43be-9e23-2c5d7cee7579',
                    title: 'Send Listing Gone Pending Congrats Email',
                },
                {
                    type: 'confirm-read',
                    stepId: 'ed28860c-58a6-4d2f-816f-21eac1637381',
                    title: 'Agent Preferences',
                },
                {
                    type: 'convert-listing',
                    stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09',
                    title: 'Accept Contract',
                },
            ];
        return [{ type: 'convert-listing', stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09', title: 'Accept Contract' }];
    }

    /**
     * A file started out as a type of sale of DE and is a transaction
     * @param isWorkflowAll
     * @param hasfeature
     * @return {*[]}
     */
    loadDoubleEndedWorkflow(isWorkflowAll, hasfeature) {
        if (isWorkflowAll || hasfeature)
            return [
                {
                    type: 'congrats-email-listing-gone-pending',
                    stepId: '3854cc79-f8ed-43be-9e23-2c5d7cee7579',
                    title: 'Send Listing Gone Pending Congrats Email',
                },
                {
                    type: 'confirm-read',
                    stepId: 'ed28860c-58a6-4d2f-816f-21eac1637381',
                    title: 'Agent Preferences',
                },
                {
                    type: 'convert-listing',
                    stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09',
                    title: 'Accept Contract',
                },
                {
                    type: 'calendar',
                    stepId: '572ace14-fb4a-4fdb-8acc-c9f4c3260c45',
                    title: 'Calendar Timeline',
                },
                {
                    type: 'introduction-buyer-email',
                    stepId: '36f299b0-f351-458a-bfe7-6a6018fefea9',
                    title: 'Introduction to Buyer',
                },
                {
                    type: 'introduction-seller-email',
                    stepId: '03582d10-0c12-4896-8d2d-42d343cdfeca',
                    title: 'Introduction to Seller',
                },
                {
                    type: 'intro-email-escrow-title',
                    stepId: '01de5ebb-78a5-4241-b787-2cf8846cf127',
                    title: 'Escrow/Title TC Introduction',
                },
                {
                    type: 'create-invoice',
                    stepId: '21b9897a-132f-4cd5-bc1f-31f12e0be5ef',
                    title: 'Create Invoice',
                },
                {
                    type: 'send-invoice',
                    stepId: 'abce0151-1e2b-43a9-ac63-3d214b3bc091',
                    title: 'Send Invoice',
                },
                {
                    type: 'file-setup-email-double-ended',
                    stepId: '9a89905a-bc78-4d0f-acca-4a2a1365ab72',
                    title: 'Confirmation of File Set-Up',
                },
            ];
        return [{ type: 'convert-listing', stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09', title: 'Accept Contract' }];
    }

    /**
     * A file that started out as a type of sale of Listing and was converted to DC
     * @param isWorkflowAll
     * @param hasfeature
     * @return {*[]}
     */
    loadListingToDoubleEndedWorkflow(isWorkflowAll, hasfeature) {
        if (isWorkflowAll || hasfeature)
            return [
                {
                    type: 'congrats-email',
                    stepId: 'dbc29b5b-d311-440b-b524-95d16b43ae99',
                    title: 'Send Congrats Email',
                },
                {
                    type: 'confirm-read',
                    stepId: 'ed28860c-58a6-4d2f-816f-21eac1637381',
                    title: 'Agent Preferences',
                },
                {
                    type: 'file-setup-email',
                    stepId: 'e078f1ee-4f9e-438c-b4b1-858ff8d12c2e',
                    title: 'Send Confirmation of File Set-Up',
                },
                {
                    type: 'convert-listing',
                    stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09',
                    title: 'Accept Contract',
                },
                {
                    type: 'congrats-email-listing-gone-pending',
                    stepId: '3854cc79-f8ed-43be-9e23-2c5d7cee7579',
                    title: 'Send Listing Gone Pending Congrats Email',
                },
                {
                    type: 'confirm-read',
                    stepId: '3cb68674-eb67-4401-a86b-ff691a22b9fd',
                    title: 'Agent Preferences',
                },
                {
                    type: 'calendar',
                    stepId: '572ace14-fb4a-4fdb-8acc-c9f4c3260c45',
                    title: 'Calendar Timeline',
                },
                {
                    type: 'introduction-buyer-email',
                    stepId: '36f299b0-f351-458a-bfe7-6a6018fefea9',
                    title: 'Introduction to Buyer',
                },
                {
                    type: 'introduction-seller-email',
                    stepId: '03582d10-0c12-4896-8d2d-42d343cdfeca',
                    title: 'Introduction to Seller',
                },
                {
                    type: 'intro-email-escrow-title',
                    stepId: '01de5ebb-78a5-4241-b787-2cf8846cf127',
                    title: 'Escrow/Title TC Introduction',
                },
                {
                    type: 'create-invoice',
                    stepId: '21b9897a-132f-4cd5-bc1f-31f12e0be5ef',
                    title: 'Create Invoice',
                },
                {
                    type: 'send-invoice',
                    stepId: 'abce0151-1e2b-43a9-ac63-3d214b3bc091',
                    title: 'Send Invoice',
                },
                {
                    type: 'file-setup-email-double-ended',
                    stepId: '9a89905a-bc78-4d0f-acca-4a2a1365ab72',
                    title: 'Confirmation of File Set-Up',
                },
            ];
        return [{ type: 'convert-listing', stepId: '195a471e-218e-412b-a3a4-fd9aef6c2c09', title: 'Accept Contract' }];
    }

    loadSalesWorkflow(isWorkflowAll, hasfeature) {
        if (isWorkflowAll || hasfeature)
            return [
                {
                    type: 'congrats-email-sale',
                    stepId: '3854cc79-f8ed-43be-9e23-2c5d7cee7579',
                    title: 'Congratulations on Your New Sale',
                },
                {
                    type: 'confirm-read',
                    stepId: 'ed28860c-58a6-4d2f-816f-21eac1637381',
                    title: 'Agent Preferences',
                },
                {
                    type: 'calendar',
                    stepId: '572ace14-fb4a-4fdb-8acc-c9f4c3260c45',
                    title: 'Calendar Timeline',
                },
                {
                    type: 'introduction-buyer-email',
                    stepId: '36f299b0-f351-458a-bfe7-6a6018fefea9',
                    title: 'Introduction to Buyer',
                },
                {
                    type: 'introduction-co-op-agent-sale-email',
                    stepId: 'd5ba2d6c-3d20-4019-8b42-f6ad3b038d15',
                    title: 'Introduction to Co-op Agent',
                },
                {
                    type: 'intro-email-escrow-title',
                    stepId: '01de5ebb-78a5-4241-b787-2cf8846cf127',
                    title: 'Escrow/Title TC Introduction',
                },
                {
                    type: 'create-invoice',
                    stepId: '21b9897a-132f-4cd5-bc1f-31f12e0be5ef',
                    title: 'Create Invoice',
                },
                {
                    type: 'send-invoice',
                    stepId: 'abce0151-1e2b-43a9-ac63-3d214b3bc091',
                    title: 'Send Invoice',
                },
                {
                    type: 'file-setup-email-sale',
                    stepId: '9a89905a-bc78-4d0f-acca-4a2a1365ab72',
                    title: 'Confirmation of File Set-Up',
                },
            ];
        return [];
    }
    loadAllSteps(){
        return [
            {
                type: 'convert',
                title: 'Accept Contract',
                section: null
            },
            {
                type: 'confirm-read',
                title: 'Agent Preferences',
                section: 'default'
            },
            {
                type: 'calendar',
                title: 'Calendar Timeline',
                section:'default'
            },
            {
                type: 'cancellation',
                title: 'Cancellation',
                section: null
            },
            {
                type: 'client-introduction-co-op-agent',
                title: 'Client Introduction to Co-op Agent',
                section: null
            },
            {
                type: 'closing-audit',
                title: 'Closing audit',
                section: null
            },
            {
                type: 'closing-checkins',
                title: 'Closing Checkins',
                section: null
            },
            {
                type: 'closing-congrats',
                title: 'Closing Congrats',
                section: 'default'
            },
            {
                type: 'closing-docs',
                title: 'Closing docs',
                section: null
            },
            {
                type: 'commission-demand',
                title: 'Commision Demand',
                section: null
            },
            {
                type: 'confirmation',
                title: 'Confirmation of File Set-Up',
                section: null
            },
            {
                type: 'congrats',
                title: 'Congratulations on Your New Property',
                section: null
            },
            {
                type: 'contingency-removal-appraisal',
                title: 'Contingency Removal Appraisal',
                section: null
            },
            {
                type: 'contingency-removal-COP',
                title: 'Contingency Removal COP',
                section: null
            },
            {
                type: 'contingency-removal-inspection',
                title: 'Contingency Removal Inspection',
                section : null
            },
            {
                type: 'contingency-removal-loan',
                title: 'Contingency Removal Loan',
                section: null
            },
            {
                type: 'create-invoice',
                title: 'Create Invoice',
                section:null
            },
            {
                type: 'earnest-money-deposit',
                title: 'Earnest Money Deposit',
                section: null
            },
            {
                type: 'client-introduction-co-op-agent-email',
                title: 'Email Introduction to Co-op Agent',
                section: null
            },
            {
                type: 'intro-email-escrow-title',
                title: 'Escrow/Title TC Introduction',
                section: null
            },
            {
                type: 'fully-executed-disclosures',
                title: 'Fully Executed Disclosures',
                section: null
            },
            {
                type: 'inspections-scheduling',
                title: 'Inspections Scheduling',
                section: null
            },
            {
                type: 'intro-escrow-title',
                title: 'Intro Escrow Title',
                section: 'default'
            },
            {
                type: 'introduction-buyer-email',
                title: 'Introduction to Buyer',
                section:'default'
            },
            {
                type: 'introduction-co-op-agent-sale-email',
                title: 'Introduction to Co-op Agent Sale',
                section: null
            },
            {
                type: 'introduction-seller-email',
                title: 'Introduction to Seller',
                section: null
            },
            
            {
                type: 'introduction-seller-email',
                title: 'Introduction to Seller',
                section: 'default'
            },
            {
                type: 'close-of-escrow',
                title: 'Scheduled Close of Escrow',
                section: null
            },
            {
                type: 'seller-signed-disclosures',
                title: 'Seller Signed Disclosures',
                section: null
            },
            {
                type: 'congrats-email',
                title: 'Send Congrats Email',
                section: null
            },
            {
                type: 'file-setup-email',
                title: 'Send Confirmation of File Set-Up',
                section:null
            },
            {
                type: 'send-invoice',
                title: 'Send invoice',
                section: 'default'
            },
            {
                type: 'verification-of-property',
                title: 'Verification of Property',
                section: null
            },
        ];
    }
    loadConstantAuditWorkflowSteps() {
        return [
            {
                type: 'closing-congrats',
                stepId: 'd0bf33f8-3b70-4e0a-ad56-8efd526f6822',
                title: 'Closing Congrats',
                isConstant: true,
                excludeFromCalendarReminders:true,
                deadline: {
                    base: 'closeOfEscsrow',
                    offset: 1,
                },
                recurrences:[],
                reminders: [],
            },
            {
                type: 'closing-checkins',
                stepId: '68001b54-5bbc-4634-9be9-c773e2e6f204',
                title: 'Closing Checkins',
                isConstant: true,
                excludeFromCalendarReminders:false,
                deadline: {
                    base: 'closeOfEscsrow',
                    offset: 1,
                },
                recurrences:["RRULE:FREQ=WEEKLY;BYDAY=TU,TH;Interval=1"],
                reminders: [0],
            },
            {
                type: 'cancellation',
                stepId: '67a756cd-0f15-4099-8bb3-11c3c7c0498f',
                title: 'Cancellation',
                isConstant: true,
                excludeFromCalendarReminders:false,
                deadline: {
                    base: 'closeOfEscsrow',
                    offset: 100,
                },
                recurrences:[],
                reminders: [],
            },
        ];
    }
}



// WEBPACK FOOTER //
// ./src/workflow/workflow-resource.js